import * as angular from "angular";
import {IController, IQService, IScope} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class PlanningDefaultDraftSelectComponent implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  private planningTemplatesDefaultDraftRef: any;
  public selectedPlanningDefaultDraft: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdSelect,
              private $log, private $q: IQService, private commonsAlertsService: CommonsAlertsService, private $planningTemplatesDefaultDraft, private $mdPanel, private $scope: IScope) {
    this.planningTemplatesDefaultDraftRef = this.$planningTemplatesDefaultDraft();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'planningDefaultDraft';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({planningDefaultDraft: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const planningDefaultDraft = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({planningDefaultDraft: planningDefaultDraft, id: selectedId});
            panel.destroy();
          } else {
            this.planningTemplatesDefaultDraftRef.$asyncValues([selectedId])
              .then((planningDefaultDrafts: any[]) => {
                this.onChange({planningDefaultDraft: planningDefaultDrafts[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({planningDefaultDraft: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedPlanningDefaultDraft = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.planningTemplatesDefaultDraftRef.$asyncValues([this.selectedId])
          .then((planningDefaultDrafts: any[]) => {
            this.selectedPlanningDefaultDraft = _.orderBy(planningDefaultDrafts, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedPlanningDefaultDraft = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedPlanningDefaultDraft, 'name', '');
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningDefaultDraftSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./planning-default-draft-select.html').default,
    controller: PlanningDefaultDraftSelectComponent
  });
